import { UnitObj } from "./quoteCartStorage";
import {
  normalHandleColor,
  specialAtlanta,
  special,
  handleColorPico,
  emtekColors,
  emtekColorsNouvel,
} from "../components/Handle/defaults";
import { handlePull } from "../components/PivotHandle/defaults";

export interface FixesObj {
  recommend?: string;
  recommend2?: string;
  recommend3?: string;
  label?: string;
  objKey?: string;
  choice?: string;
  fix?: string[];
  label2?: string;
  objKey2?: string;
  choice2?: string;
  fix2?: string[];
  label3?: string;
  objKey3?: string;
  choice3?: string;
  fix3?: string[];
  label4?: string;
  objKey4?: string;
  choice4?: string;
  fix4?: string[];
  recommendList?: any;
}

const boltHingeOptionsPico = ["Black", "Stainless Steel"];

const shootBoltOptions = ["Brushed Chrome", "Bronze", "Black", "White"];
const hingeOptions = ["Stainless Steel", "Bronze"];

const boltHingeOptionsBifoldAlum = ["Black", "Dark Silver"];

export default function checkForCommonHardware(unit: UnitObj) {
  const {
    doorType,
    material,
    headTrackColor,
    sillColor,
    exteriorCladColor,
    weatherStripColor,
    withHandle,
    handleStyle,
    handleColor,
    shootBoltColor,
    hingeColor,
  } = unit;

  const isPico = unit.stileCategory === "Pico";

  const isAluminum = material === "All Aluminum";

  let nonMatches: FixesObj[] = [];

  if (doorType === "Pivot" && unit.pivotBackPlateColor && hingeColor) {
    const allValues = [unit.pivotBackPlateColor, hingeColor];

    if (handleStyle === "Dallas Lever" && handleColor) {
      allValues.push(handleColor);
    } else if (
      handlePull.some((itm) => itm.label === handleStyle) &&
      handleColor
    ) {
      allValues.push(handleColor);
    }

    if (unit.pivotMagnet && unit.pivotMagnetColor) {
      allValues.push(unit.pivotMagnetColor);
    }

    const matchColor = allValues[0]?.includes("Black")
      ? "Black"
      : allValues[0]?.includes("Steel")
        ? "Steel"
        : "";

    if (allValues.every((itm) => itm.includes(matchColor))) {
      nonMatches = [...nonMatches];
    } else {
      const fix = ["Stainless Steel", "Black"];

      let fixes: FixesObj = {
        recommend: "Match Finishes",
        label: "Back Plate",
        objKey: "pivotBackPlateColor",
        choice: unit.pivotBackPlateColor,
        fix: fix,
        label2: "Hinge Plate",
        objKey2: "hingeColor",
        choice2: hingeColor,
        fix2: fix,
      };

      if (handleStyle === "Dallas Lever" && handleColor) {
        fixes["label3"] = "Handle";
        fixes["objKey3"] = "handleColor";
        fixes["choice3"] = handleColor;
        fixes["fix3"] = ["Stainless Steel", "Matte Black"];
      } else if (
        handlePull.find((itm) => itm.label === handleStyle) &&
        handleColor
      ) {
        const isEmtek = handleStyle === "Strata" || handleStyle === "Forge";

        let handlePullColors = ["Brushed Stainless Steel"];

        if (handleStyle !== "Monarch") {
          handlePullColors.push("Matte Black");
        }

        if (isEmtek) {
          handlePullColors.push("Satin Brass Stainless Steel");
        }

        fixes["label3"] = "Handle";
        fixes["objKey3"] = "handleColor";
        fixes["choice3"] = handleColor;
        fixes["fix3"] = handlePullColors;
      }

      if (unit.pivotMagnet && unit.pivotMagnetColor) {
        const entryNum = fixes["label3"] ? 4 : 3;

        fixes[`label${entryNum}`] = "Ghostop";
        fixes[`objKey${entryNum}`] = "pivotMagnetColor";
        fixes[`choice${entryNum}`] = unit.pivotMagnetColor;
        fixes[`fix${entryNum}`] = fix;
      }

      nonMatches.push(fixes);
    }
  }

  if (headTrackColor && sillColor) {
    if (doorType?.includes("Bi-fold") && isAluminum) {
      // if (headTrackColor !== sillColor) {
      //   nonMatches.push({
      //     label: "Head Track",
      //     objKey: "headTrackColor",
      //     choice: headTrackColor,
      //     fix: ["Jet Black", "Clear Anodized"],
      //     recommend: "Match Head Track and Sill Finish",
      //     label2: "Sill",
      //     objKey2: "sillColor",
      //     choice2: sillColor,
      //     fix2: ["Jet Black", "Clear Anodized"],
      //   });
      // }
    } else if (
      //head track color and sill choice is a match
      headTrackColor.replace("Anodized", "").trim() !==
      sillColor.replace("Anodized", "").trim()
    ) {
      const headTrackBw = !headTrackColor.includes("Anodized")
        ? `${headTrackColor} Anodized`
        : headTrackColor;

      nonMatches.push({
        label: "Head Track",
        objKey: "headTrackColor",
        choice: headTrackBw,
        fix: ["Bronze Anodized", "Clear Anodized"],
        recommend: "Match Head Track and Sill Finish",
        label2: "Sill",
        objKey2: "sillColor",
        choice2: sillColor,
        fix2: ["Bronze Anodized", "Clear Anodized"],
      });
    }
  }

  if (
    exteriorCladColor &&
    !exteriorCladColor.includes("Custom") &&
    weatherStripColor
  ) {
    const cladMatch = {
      "Carbon Black": "Black",
      "Espresso Brown": "Bronze",
      "Sandcastle Tan": "Bronze",
      "Linen White": "White",
      "Clear Anodized": "White",
    };

    const isMatch = cladMatch[exteriorCladColor] === weatherStripColor;

    if (!isMatch) {
      nonMatches.push({
        label: "Clad",
        objKey: "exteriorCladColor",
        choice: exteriorCladColor,
        fix: [
          "Linen White",
          "Clear Anodized",
          "Carbon Black",
          "Espresso Brown",
          "Sandcastle Tan",
        ],
        recommend: "Carbon Black Clad Finish with Black Weather Strip",
        recommend2:
          "Espresso Brown or Sandcastle Tan Clad Finish with Bronze Weather Strip",
        recommend3:
          "Linen White or Clear Anodized Clad Finish with White Weather Strip",
        label2: "Weather Strip",
        objKey2: "weatherStripColor",
        choice2: weatherStripColor,
        fix2: ["Black", "Bronze", "White"],
      });
    }
  }

  if (
    handleStyle &&
    handleColor &&
    doorType !== "Slider" &&
    withHandle &&
    withHandle === "Add Handle Set" &&
    !isAluminum
  ) {
    function formatText(arg: {
      shootBolt_color: string;
      hinge_color: string;
      handle_color: string;
    }) {
      return `${arg.shootBolt_color} Shoot-Bolt with ${arg.hinge_color} Hinges to match ${arg.handle_color} Handle`;
    }

    let recommendList = {
      "Rustic Umber": formatText({
        shootBolt_color: "Bronze",
        hinge_color: "Bronze",
        handle_color: "Rustic Umber",
      }),
      "Oil Rubbed Bronze *": formatText({
        shootBolt_color: "Bronze",
        hinge_color: "Bronze",
        handle_color: "Oil Rubbed Bronze",
      }),
      "Oil Rubbed Bronze": formatText({
        shootBolt_color: "Bronze",
        hinge_color: "Bronze",
        handle_color: "Oil Rubbed Bronze",
      }),
      "Satin Brass": formatText({
        shootBolt_color: "Bronze",
        hinge_color: "Bronze",
        handle_color: "Satin Brass",
      }),
      "Satin Nickel(Resista Finish)": formatText({
        shootBolt_color: "Brushed Chrome",
        hinge_color: "Stainless Steel",
        handle_color: "Satin Nickel",
      }),
      "Polished Nickel": formatText({
        shootBolt_color: "Brushed Chrome",
        hinge_color: "Stainless Steel",
        handle_color: "Polished Nickel",
      }),
      "Brushed Stainless Steel": formatText({
        shootBolt_color: "Brushed Chrome",
        hinge_color: "Stainless Steel",
        handle_color: "Brushed Stainless Steel",
      }),
      "Polished Chrome": formatText({
        shootBolt_color: "Brushed Chrome",
        hinge_color: "Stainless Steel",
        handle_color: "Polished Chrome",
      }),
      "Matte Black": isPico
        ? formatText({
            shootBolt_color: "Black",
            hinge_color: "Black",
            handle_color: "Matte Black",
          })
        : formatText({
            shootBolt_color: "Black",
            hinge_color: "Bronze",
            handle_color: "Matte Black",
          }),
      "Flat Black": formatText({
        shootBolt_color: "Black",
        hinge_color: "Bronze",
        handle_color: "Flat Black",
      }),
      White: formatText({
        shootBolt_color: "White",
        hinge_color: "Stainless Steel",
        handle_color: "White",
      }),
      "Alpine Frost": formatText({
        shootBolt_color: "Stainless Steel",
        hinge_color: "Stainless Steel",
        handle_color: "Alpine Frost",
      }),
      Black: formatText({
        shootBolt_color: "Black",
        hinge_color: "Black",
        handle_color: "Black",
      }),
      "Dark Silver": formatText({
        shootBolt_color: "Dark Silver",
        hinge_color: "Dark Silver",
        handle_color: "Dark Silver",
      }),
    };

    let fixes: FixesObj = {
      label: "Handle",
      objKey: "handleColor",
      choice: handleColor,
      fix: [],
      recommendList,
    };

    if (handleColor) {
      if (handleStyle === "Nouvel *") {
        fixes.fix = emtekColorsNouvel;
      } else if (handleStyle === "Smart Lock *") {
        fixes.fix = emtekColors;
      } else if (handleStyle === "Verona") {
        fixes.fix = normalHandleColor;
      } else if (handleStyle === "Savannah" || handleStyle === "Toulon") {
        fixes.fix = !isPico
          ? handleColorPico
          : handleColorPico.filter((color) => color !== "Rustic Umber");
      } else if (isAluminum && doorType?.includes("Bi-fold")) {
        fixes.fix = boltHingeOptionsBifoldAlum;
      } else if (handleStyle !== "Atlanta *") {
        fixes.fix = special;
      } else {
        fixes.fix = specialAtlanta;
      }
    }

    if (
      handleColor === "Satin Nickel(Resista Finish)" ||
      handleColor === "Alpine Frost" ||
      handleColor === "Polished Nickel" ||
      handleColor === "Polished Chrome" ||
      handleColor === "Brushed Stainless Steel"
    ) {
      if (shootBoltColor && hingeColor) {
        const pairedShootBolt = isPico ? "Stainless Steel" : "Brushed Chrome";
        const pairedHinge = "Stainless Steel";

        shootBoltHingeHandle(
          fixes,
          shootBoltColor,
          hingeColor,
          pairedShootBolt,
          pairedHinge,
          isPico,
        );
      }

      if (fixes["label2"]) nonMatches.push(fixes);
    } else if (
      handleColor === "Rustic Umber" ||
      handleColor === "Oil Rubbed Bronze *" ||
      handleColor === "Satin Brass"
    ) {
      if (shootBoltColor && hingeColor) {
        const pairedShootBoltHinge = isPico ? "Black" : "Bronze";

        shootBoltHingeHandle(
          fixes,
          shootBoltColor,
          hingeColor,
          pairedShootBoltHinge,
          pairedShootBoltHinge,
          isPico,
        );
      }

      if (fixes["label2"]) nonMatches.push(fixes);
    } else if (handleColor === "Matte Black" || handleColor === "Flat Black") {
      if (shootBoltColor && hingeColor) {
        const pairedShootBolt = "Black";
        const pairedHinge = isPico ? "Black" : "Bronze";

        shootBoltHingeHandle(
          fixes,
          shootBoltColor,
          hingeColor,
          pairedShootBolt,
          pairedHinge,
          isPico,
        );
      }

      if (fixes["label2"]) nonMatches.push(fixes);
    } else if (handleColor === "White") {
      if (shootBoltColor && hingeColor) {
        const pairedShootBolt = "White";
        const pairedHinge = "Stainless Steel";

        shootBoltHingeHandle(
          fixes,
          shootBoltColor,
          hingeColor,
          pairedShootBolt,
          pairedHinge,
          isPico,
        );
      }

      if (fixes["label2"]) nonMatches.push(fixes);
    } else if (handleColor === "Black") {
      if (shootBoltColor && hingeColor) {
        const pairedShootBolt = "Black";
        const pairedHinge = "Black";

        shootBoltHingeHandle(
          fixes,
          shootBoltColor,
          hingeColor,
          pairedShootBolt,
          pairedHinge,
          false,
          true,
        );
      }

      if (fixes["label2"]) nonMatches.push(fixes);
    } else if (handleColor === "Dark Silver") {
      if (shootBoltColor && hingeColor) {
        const pairedShootBolt = "Dark Silver";
        const pairedHinge = "Dark Silver";

        shootBoltHingeHandle(
          fixes,
          shootBoltColor,
          hingeColor,
          pairedShootBolt,
          pairedHinge,
          false,
          true,
        );
      }

      if (fixes["label2"]) nonMatches.push(fixes);
    }
  } else {
    if (shootBoltColor && hingeColor && !isAluminum) {
      let pairedMatches = true;

      if (isPico) {
        if (hingeColor !== shootBoltColor) {
          pairedMatches = false;
        }
      } else {
        if (
          hingeColor === "Stainless Steel" &&
          shootBoltColor !== "Brushed Chrome" &&
          shootBoltColor !== "White"
        ) {
          pairedMatches = false;
        } else if (
          hingeColor !== "Stainless Steel" &&
          (shootBoltColor === "Brushed Chrome" || shootBoltColor === "White")
        ) {
          pairedMatches = false;
        } else if (
          shootBoltColor !== "Bronze" &&
          shootBoltColor !== "Black" &&
          hingeColor === "Bronze"
        ) {
          pairedMatches = false;
        } else if (
          (shootBoltColor === "Bronze" || shootBoltColor === "Black") &&
          hingeColor !== "Bronze"
        ) {
          pairedMatches = false;
        }
      }

      if (!pairedMatches) {
        nonMatches.push({
          label: "Shoot Bolt",
          objKey: "shootBoltColor",
          choice: shootBoltColor,
          fix: isPico ? boltHingeOptionsPico : shootBoltOptions,
          label2: "Hinge",
          objKey2: "hingeColor",
          choice2: hingeColor,
          fix2: isPico ? boltHingeOptionsPico : hingeOptions,
          recommend: isPico
            ? "Match Shoot-Bolt and Hinge Finishes"
            : "Brushed Chrome Shoot-Bolt with Stainless Steel Hinges",
          recommend2: isPico
            ? ""
            : "White Shoot-Bolt with Stainless Steel Hinges",
          recommend3: isPico
            ? ""
            : "Bronze or Black Shoot-Bolt with Bronze Hinges",
        });
      }
    }
  }

  return nonMatches;
}

function shootBoltHingeHandle(
  fixes: FixesObj,
  unitShootBolt: string,
  unitHinge: string,
  shootBolt: string,
  hinge: string,
  isPico: boolean,
  isAlumBifold: boolean = false,
) {
  const shootBoltArr = isAlumBifold
    ? boltHingeOptionsBifoldAlum
    : isPico
      ? boltHingeOptionsPico
      : shootBoltOptions;
  const hingeArr = isAlumBifold
    ? boltHingeOptionsBifoldAlum
    : isPico
      ? boltHingeOptionsPico
      : hingeOptions;

  if (unitShootBolt !== shootBolt || unitHinge !== hinge) {
    fixes["label2"] = "Shoot Bolt";
    fixes["objKey2"] = "shootBoltColor";
    fixes["choice2"] = unitShootBolt;
    fixes["fix2"] = shootBoltArr;

    fixes["label3"] = "Hinge";
    fixes["objKey3"] = "hingeColor";
    fixes["choice3"] = unitHinge;
    fixes["fix3"] = hingeArr;
  }

  return fixes;
}
